import { useState, useEffect } from "react";
import { Button } from "../../components";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./styles.css";

const Profile = () => {
	const [scores, setScores] = useState([]);
	const navigator = useNavigate();

	const handleLobby = () => {
		navigator("../lobby");
	};

	useEffect(() => {
		const fetchUserScores = async () => {
			const config = {
				headers: {
					Authorization: "Bearer " + localStorage.getItem("token")
				}
			};
			const userScores = await axios.get(
				`${process.env.REACT_APP_USERS_API_URL}/auth/`,
				config
			);
			userScores.data.reverse();
			setScores(userScores.data);
		};
		fetchUserScores();
	}, []);

	return (
		<div className="profileContainer">
			<div className="profileWrapper">
				<h1 className="profile-title">{`Hello ${
					JSON.parse(localStorage.getItem("user")).username
				}`}</h1>
				{scores.length === 0 ? (
					<>
						<h3>You don't have any stats</h3>
						<h3>Please go play some games</h3>
						<Button
							onClick={handleLobby}
							text={
								<>
									Play a Game<span aria-hidden></span>
									<span aria-hidden class="cybrBtnGlitch">
										Play a Game
									</span>
								</>
							}
						/>
					</>
				) : (
					<>
						<h3 className="profile-stats">Here are your stats</h3>
						<div className="profile-scores">
							<table>
								<tr>
									<th>Number of Questions</th>
									<th>Category</th>
									<th>Difficulty</th>
									<th>Question Type</th>
									<th>Score</th>
								</tr>
								{scores.map((score) => {
									return (
										<tr className="tr">
											<td>{score.noOfQuestions}</td>
											<td>{score.category}</td>
											<td>{score.difficulty}</td>
											<td>{score.type}</td>
											<td>
												{score.score}/{score.noOfQuestions}
											</td>
										</tr>
									);
								})}
							</table>
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default Profile;
